import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxStarsModule } from 'ngx-stars';
import { HttpService } from '../../service/http.service';
import { CONSULTANT_LIST, GET_WALLET_TRANSACTION, PROFILE_DATA, USER_STATUS_FOR_CALL_CHAT } from '../../service/payload';
import { GlobalService } from '../../service/global.service';
import { HomeLawyerSectionComponent } from "../../index/home-lawyer-section/home-lawyer-section.component";
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { AddwalletComponent } from '../addwallet/addwallet.component';
import { CallFormComponent } from "../call/call-form/call-form.component";


@Component({
  selector: 'app-advisor-profile',
  standalone: true,
  imports: [
    CommonModule,
    NgxStarsModule,
    HomeLawyerSectionComponent,
    AddwalletComponent,
    CallFormComponent
],
  templateUrl: './advisor-profile.component.html',
  styleUrl: './advisor-profile.component.scss'
})
export class AdvisorProfileComponent {

  showLowBalanceModal = false;

  constructor(private service: HttpService, public gS: GlobalService,
    private _router: ActivatedRoute, private toast: ToastrService,private router: Router) {
    // this.urldata = this._router.snapshot.params['id'];
    // console.log(this.urldata);

    // this.getData();
  }

  headingAstro: any = "Expert with similar expertise";

  isFilter: boolean = false;
  pageNo: number = 0;
  pageSize: number = 10;
  moduleName: string = 'CHAT';
  sortBy: boolean = false;
  sortType: any = '';

  searchQuery: any = '';

  dataList: Array<any> = [];
  isLowBalance: boolean = false;
  minBalance: number = 0;
  advisorName: string = '';
  serviceName: string = '';
  advisorProfile: any = {}
  showShortDesciption = true;
  ngOnInit() {
    this._router.params.subscribe(params => {
      this.urldata = params['id'];
      console.log(this.urldata);
      this.getData();
    });
    this.getLawyerData();
  }

  getLawyerData() {
    let payload: CONSULTANT_LIST = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      moduleName: this.moduleName,
      platformType: this.gS.PlatformType,
      sortBy: this.sortBy,
      projectId: this.gS.projectId,
      sortType: this.sortType,
      timeZone: this.gS.timeZone,
      customerId: this.gS.customerId,
      searchQuery: this.searchQuery,

    }
    this.service.getLawyerList(payload).then((res: any) => {
      let value = res?.data;
      value.forEach((item: any) => {
        if (item?.expertiseArea) {
          item.expertiseArea = item?.expertiseArea.split(",");
        }
        this.dataList.push(item);
      });
      console.log(this.dataList);
    });
  }

  urldata: any;
  specializationArea: Array<any> = [];
  expertiseArea: Array<any> = [];


  getData() {

    let payload: PROFILE_DATA = {
      
      timeZone: this.gS.timeZone,
      profileUrl: this.urldata,
      projectId:this.gS.projectId

    }

    this.service.getAstrologerProfile(payload).subscribe((data) => {
      this.advisorProfile = data;
      this.advisorProfile = this.advisorProfile.data;

      if (this.advisorProfile) {
        this.specializationArea = this.advisorProfile?.specializationArea.split(',');
        this.expertiseArea
          = this.advisorProfile?.expertiseArea.split(',')
      }
    }, (error) => {
      console.log(error);
    });

  }
  alterDescriptionText() {
    this.showShortDesciption = !this.showShortDesciption
  }


  async chatNow(servicePrice: any) {
    let loginStatus = await this.gS?.getUserLogginStatus();
    if (loginStatus) {
      let balance = 0;
      await this.getWalletBalance(0, 0).then((res: any) => {
        balance = res?.availableBalance;
        if (balance >= (5 * servicePrice)) {
          this.userStatusForCallChat(this.gS?.userData?.id, this.advisorProfile?.id).then((res: any) => {
            if (res) {
              
              let astrologerData = {
                id: this.advisorProfile?.id,
                servicePrice: servicePrice,
                astrologerName: this.advisorProfile?.astrologerName
              }
              this.gS.navigateWithExtras('chat-form', {
                state: {
                  astrologerData: astrologerData,
                  isFree: false
                }
              })
            }
          })
        } else {
         
          this.minBalance = 5 * servicePrice;
          this.advisorName = this.advisorProfile?.astrologerName;
          this.serviceName = 'start your Chat';
          this.isLowBalance = true;
          this.showLowBalanceModal = true;
        }
      });
    } else {
      this.gS.navigate('login');
    }
  }
  getWalletBalance(pageNo: number, pageSize: number) {
    return new Promise((resolve, reject) => {
      let payload: GET_WALLET_TRANSACTION = {
        customerId: this.gS.userData?.id,
        pageNo: pageNo,
        pageSize: pageSize,
        projectId: this.gS.projectId
      }
      this.service.getWalletTransaction(payload).then((res: any) => {
        if (res?.status == 'success') {
          this.gS.userBalance = res?.availableBalance;
          resolve(res);
        }
      })
    })
  }


  userStatusForCallChat(userId: any, consultantId: any) {
    return new Promise((resolve, reject) => {
      let payload: USER_STATUS_FOR_CALL_CHAT = {
        consultantId: consultantId,
        userId: userId,
        timezone: this.gS.timeZone,
        isCall: 0,
        appId: 3,
        businessId: 1,
        appVersionUser: this.gS.appVersion,
        isPo: 0
      }

      this.service.userStatusForCallChat(payload).then((res: any) => {
        if (res?.status == 'success') {
          resolve(true);
        } else {
          // this.toastCtrl.error(res.reason);
          resolve(false);
        }
      })
    })
  }


  opencCallForm: boolean = false;
  isPopupOpen = false;
  async callNow(servicePrice: any) {
    if ((this.gS.timeZone.toLowerCase() === 'Asia/Kolkata'.toLowerCase()) || (this.gS.timeZone.toLowerCase() === 'Asia/Calcutta'.toLowerCase())) {
      let loginStatus = await this.gS?.getUserLogginStatus();
      if (loginStatus) {
        let balance = 0;
        await this.getWalletBalance(0, 0).then((res: any) => {
          balance = res?.availableBalance;
          if (balance >= (5 * servicePrice)) {
            this.userStatusForCallChat(this.gS?.userData?.id, this.advisorProfile?.id).then((res: any) => {
              if (res) {
                this.opencCallForm = true;
                let astrologerData = {
                  id: this.advisorProfile?.id,
                  servicePrice: servicePrice,
                  astrologerName: this.advisorProfile?.astrologerName
                }
                this.gS.navigateWithExtras('call-form', {
                  state: {
                    astrologerData: astrologerData,
                    isFree: false
                  }
                })
              }
            })
          } else {
            this.minBalance = 5 * servicePrice;
            this.advisorName = this.advisorProfile?.astrologerName;
            this.serviceName = 'start your Call';
            this.isLowBalance = true;
            this.showLowBalanceModal = true;
          }
        });
      } else {
        this.gS.navigate('login');
      }
    } else {
      this.toast.error('Currently call service is available in India only, Meanwhile please connect on chat with Consultants.')
    }
  }


  closePopup($event: any) {
    this.isPopupOpen = false;
    this.opencCallForm = false;
  }
  successCall($event: any) {
    location.reload();
  }

  unavailabel() {
    console.log('function is called');
    this.toast.warning('Advisor currently Not Available');
  }




  balance:10;

  checkBalance(balance: number) {
    if (balance < 10) {
      this.showLowBalanceModal = true;
    }
  }

  closeModal() {
    this.showLowBalanceModal = false;
  }

  goToWallet() {
    this.router.navigate(['/astroapp-wallet']); 
    this.closeModal();
   
  }


 


}
